<div id="myorder-container" >
    <div class="orders-container-title">Order history</div>
    <ngx-spinner type="ball-spin-clockwise" bdColor="rgb(249, 249, 251)" size="medium" color="#ef870a" [fullScreen]="false" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;"></ngx-spinner>
    <div *ngFor="let item of userOrdersResult.data" class="order-box">
        <div class="orders-box-date">{{item.order_date}}</div>
        <div class="order-box-inner">
            <div class="order-box-inner-content">
                <div class="order-box-inner-content-box">
                    <div class="order-box-inner-content-orderId">
                        <span>Order</span>
                        <span class="order-box-orderId">#{{item.id}}</span>
                    </div>
                    <div class="order-box-inner-content-status">
                        <span class="status-text">Status:</span>
                        <span class="order-box-inner-content-status-button" [style.background-color]="getOrderStatus(item.status).color">
                            <img [src]="getOrderStatus(item.status).icon">
                            {{getOrderStatus(item.status).text}}
                        </span>
                        <button class="btn py-2" style="border-radius: 200px; margin-right: 2rem; background-color: #FF897D;" (click)="openPayment(item.to_pay)" *ngIf="item.to_pay">Pay now </button>
                    
                    </div>
                </div>
                <div class="order-box-inner-content-actions-box" >
                    <div class="order-box-inner-content-details" (click)="openPauseSubscription(item.id)" *ngIf="isSubscriptionActive(item) && !isSubscriptionFlexi(item) && !item.pause_from">
                        <img src="assets/images/pause-circle.svg">
                        <span class="order-box-inner-content-details-link">Skip</span>
                    </div>

                    <div class="order-box-inner-content-details" (click)="openDetails(item.id)">
                        <img src="assets/images/order-details-link-icon.svg">
                        <span class="order-box-inner-content-details-link" >Details</span>
                    </div>
                </div>
            </div>
            <div *ngIf="item.cancel_from">
                Cancelation is set for: {{item.cancel_from}}
            </div>
            <div *ngIf="item.pause_from">
                Pause period: {{item.pause_from }} - {{ item.pause_until }}
            </div>

       </div>
    </div>

    <div *ngIf="(userOrdersResult.prev_page_url != null || userOrdersResult.next_page_url != null) && !loading" style="display: flex; align-items: center; margin-top: 15px;">
        <div class="text-black pi pi-angle-double-left" style="font-size: 2rem; cursor: pointer;" *ngIf="userOrdersResult.prev_page_url != null" (click)="previousOrders()"></div>
        <div class="text-black pi pi-angle-double-right" style="font-size: 2rem; cursor: pointer; margin-left: auto;" *ngIf="userOrdersResult.next_page_url != null" (click)="nextOrders()"></div>
    </div>
</div>

<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="detailsPopUpVisibility" [style]="{ height: '90%' }" (onHide)="closeDetails()">
    <div *ngIf="!loading && order">
        <div class="popup-header">
            <span>Order #{{order.id}} - {{formatDate(order.created_at)}}</span>
        </div>

        <p-divider></p-divider>

<!-- hidden as apparently people think this button autorenew weeks, not the entire subscription
        
        <div *ngIf="isSubscriptionActive(order)">
            <div style="display: flex; align-items: center; gap: 1rem; justify-content: flex-end;">
                <div>Subscription Auto Renew:</div>
                <p-inputSwitch [(ngModel)]="order.auto_renew" (onChange)="saveAutoRenew()"/>
            </div>
        </div>
        <p-divider *ngIf="isSubscriptionActive(order)"></p-divider>
-->

        <!-- address field -->
        <div style="display: flex; align-items: center; gap: 1rem; justify-content: space-between;">
            <div>
                <span *ngIf="!enableEditAddress">{{order.address}}, {{order.zip}}, {{order.city}}</span>
                <app-address-search *ngIf="enableEditAddress" (addressSelected)="onAddressSelected($event)"></app-address-search>
            </div>
            <ng-container *ngIf="isSubscriptionValidState(order)">
                <div *ngIf="!enableEditAddress">
                    <img src="assets/images/pencil.png" style="height: 14px;width: 14px;margin-left: 0.5rem;cursor: pointer;" alt="" (click)="editAddress()">
                    <span class="mx-2" style="cursor: pointer;" (click)="editAddress()">edit</span>
                </div>
                <div *ngIf="enableEditAddress">
                    <img src="assets/images/pencil.png" style="height: 14px;width: 14px;margin-left: 0.5rem;cursor: pointer;" alt="" (click)="closeEditAddress()">
                    <span class="mx-2" style="cursor: pointer;" (click)="closeEditAddress()">close</span>
                </div>
            </ng-container>
        </div>

        <p-divider></p-divider>
        
        <div class="main-content-container" *ngIf="order_details.length > 0">
            <ng-container *ngFor="let item of order_details; index as j">
                <p-divider *ngIf="j != 0"></p-divider>
                <div class="week-summary">
                    <div class="week-summary-header">
                        <div class="week-summary-title">
                            <span>Week {{item.week}}</span>
                        </div>
                        <div class="week-summary-price">
                            <p *ngIf="!hasDiscountForWeek(item.week)"><span class="discounted-price">  £{{getOriginalWeekPrice(item.week)}}</span></p>

                            <div class="price-stack" *ngIf="hasDiscountForWeek(item.week)">
                                <p style="margin:0;"><span class="full-price"> £{{getOriginalWeekPrice(item.week)}}</span><span class="discounted-price">  £{{getDiscountedWeekPrice(item.week)}}</span></p>
                                <p class="discount-percentage-box">Discount {{getDiscountAppliedWeekPercentage(item.week)}}%</p>
                            </div>
                        </div>
                    </div>
                    <div class="week-orders-details-container">
                        <div class="week-orders-details-box" *ngFor="let deliveryGroup of groupByDeliveryDate(item.details)">
                            <div>
                                <span>Delivery: {{deliveryGroup.delivery_date | date:'dd/MM/yyyy'}}</span>
                            </div>
                            <p-divider></p-divider>
                            <div *ngFor="let ord of deliveryGroup.orders; index as i" [class]="i%2==0 ? 'meal-row-container back-grey' : 'meal-row-container'">
                                <div class="meal-row" *ngIf="ord.meal_id">
                                    <span class="order-meal-name">{{ord.meal.name}}</span>
                                    <span class="order-meal-amount">x{{ord.count}}</span>
                                </div>
                                <div *ngIf="ord.meal_user_id">
                                    <span>Bespoked Meal</span>
                                    <br>
                                    <div class="meal-row">
                                        <span class="order-meal-name">{{ord.meal.protein_batch.name}}</span>
                                        <span class="order-meal-amount">{{ord.meal.protein_amount.amount}}g</span>
                                    </div>
                                    <div class="meal-row">
                                        <span class="order-meal-name">{{ord.meal.carb_batch.name}}</span>
                                        <span class="order-meal-amount">{{ord.meal.carb_amount.amount}}g</span>
                                    </div>
                                    <div class="meal-row">
                                        <span class="order-meal-name">{{ord.meal.veg_batch.name}}</span>
                                        <span class="order-meal-amount">{{ord.meal.veg_amount.amount}}g</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="isSubscriptionValidState(order) && canEditWeek(order_details, item.week)">
                        <div class="edit-meals-button" (click)="openEditWeek(order.id, item.week)">
                            <span>Edit meals</span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            
            <ng-container *ngIf="isSubscriptionActive(order) && !order.cancel_from">
                <p-divider></p-divider>
                <div style="justify-items: center;">   
                    <button class="cancel-subscription-button" (click)="cancelSubscription()" *ngIf="!showCancelSubscriptionForm">Cancel Subscription</button>
                    <form *ngIf="showCancelSubscriptionForm" [formGroup]="cancellationForm" (ngSubmit)="sendSubscriptionCancelation()" class="cancellation-form">
                        <p class="cancel-subscription-textarea-title">Please tell us in a few words why you'd like to cancel your subscription</p>
                        <textarea formControlName="reason" required class="cancellation-textarea" rows="7"></textarea>
                        <p class="cancel-subscription-textarea-title">From which date you will like to cancel?</p>
                        <div class="cancellation-dropdown-wrapper">
                            <p-dropdown formControlName="cancelDate" [options]="cancellationDates" optionLabel="label" optionValue="value" placeholder="Select cancellation date"></p-dropdown>
                        </div>
                        <button type="submit" class="request-cancelation-button" [disabled]="!cancellationForm.valid">Request Cancelation</button>
                    </form>
                </div>
            </ng-container>
            
        </div>
    </div>
    
</p-dialog>


<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="pauseSubscriptionPopUpVisibility"  (onHide)="closePauseSubscription()">
    <div *ngIf="!loading">
            <div class="popup-header">
                <span>Pause Subscription</span>
            </div>
        <div>
            <form [formGroup]="pauseSubscriptionForm" (ngSubmit)="sendSubscriptionPause()" class="pause-form">
                <div class="pause-subscription-title">Select the deliveries you want to skip</div>
                <div class="pause-dropdown-wrapper">
                    <p-dropdown formControlName="pauseFromDate" [options]="pauseDates" optionLabel="label" optionValue="value" placeholder="Pause From" (onChange)="onPauseFromDateChange($event.value)" appendTo="body" styleClass="w-100"></p-dropdown>
                    <p-dropdown formControlName="pauseToDate" [options]="filteredPauseDates" optionLabel="label" optionValue="value" placeholder="Restart From"  appendTo="body" styleClass="w-100"></p-dropdown>
                </div>
                <div style="display: flex; justify-content: center; margin-top: clamp(1rem, 3rem, 5vh);">
                   <button type="submit" style="background-color: #ef870a; color: white; border: none; padding: clamp(0.5rem, 0.75rem, 1rem) clamp(1rem, 2rem, 3rem); font-size: clamp(0.875rem, 1rem, 1.125rem); border-radius: 25px; cursor: pointer;" [disabled]="!pauseSubscriptionForm.valid">Confirm</button>
                </div>
            </form>
        </div>
    </div>
    
</p-dialog>


<p-dialog [draggable]="false" [resizable]="false" [(visible)]="paymentPopUpVisibility" [breakpoints]="{ '979px': '90vw' }" [styleClass]="'custom-dialog'" [style]="{ width: '40%', height: '60%' }" >
    <ng-template pTemplate="header">
        <div class="mt-4 align-items-center justify-content-center w-100 text-center">
            <span class="fm-prompt weight-500" style="font-size: 1.429rem;color: #0F0F1F;">Payment</span>
        </div>
    </ng-template>
    <div id="layoutHome" class="web-center">
        <div style="width: 85%;">
            <div class="w-100 row mt-4 row mb-5" style="max-width: 100%;">
                <form novalidate [formGroup]="stripeTest" class="fm-rubik">
                    <div class="col-md-12 w-100">
                        <div>
                            <input type="text" formControlName="name" class="p-2 payment-input w-100 weight-200" placeholder="Full Name" />
                        </div>
                    </div>
                </form>
                <div style="margin-top: 20px;">
                    <ngx-stripe-card class="mb-4 mt-4" [options]="cardOptions" [elementsOptions]="elementsOptions"></ngx-stripe-card>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-custom" *ngIf="to_pay">
        <div style="display: flex; justify-content: space-between; padding: 5px; margin-right: 5px; align-items: center;">
            <div style="display: flex; align-items: center;">

            </div>
            <div style="display: flex; align-items: center;">
                <div style="display: flex; flex-direction: column;" [style]="isMobile ? 'font-size: 13px;' : 'font-size: medium;'">
                    <span>You pay:</span>
                    <span class="weight-500 fm-rubik" style="font-weight: 500;color: #2C2C30;">£{{to_pay.amount}}</span>
                </div>
                <div style="width: 20px;"></div>
                <div>
                    <app-orange-button [text]="'Pay'" (action)="pay()" [size]="'md'"></app-orange-button>
                </div>
            </div>
        </div>
    </div>
</p-dialog>


